import { Canvas2DRenderer } from './Canvas2DRenderer.js';
import { ThreeJSRenderer } from './ThreeJSRenderer.js';

export class RendererFactory {
  static create(type, canvas) {
    switch (type) {
      case 'threejs':
      case '3d':
        return new ThreeJSRenderer(canvas);
      case 'canvas2d':
      case '2d':
      default:
        return new Canvas2DRenderer(canvas);
    }
  }
  
  static async preloadThreeJS() {
    // Preload Three.js module to avoid lag on first toggle
    try {
      console.log('Preloading Three.js renderer...');
      await import('./ThreeJSRenderer.js');
      console.log('Three.js renderer preloaded successfully');
      return true;
    } catch (error) {
      console.warn('Failed to preload Three.js:', error);
      return false;
    }
  }
}